import { createFileRoute, notFound, redirect } from "@tanstack/react-router"
import { friendsQueryOptions } from "@/entities/friend"
import { BlockedProfilePage } from "@/pages/profile/blacklist"

export const Route = createFileRoute(
	"/_authenticated/profile/blacklist/$friendId",
)({
	params: {
		parse: (raw) => {
			const friendId = Number(raw.friendId)
			if (!Number.isFinite(friendId)) throw notFound()
			return { friendId }
		},
		stringify: (parsed) => ({ friendId: String(parsed.friendId) }),
	},
	loader: async ({ context, params }) => {
		const friends = await context.queryClient.query({
			...friendsQueryOptions(context.userId),
			staleTime: "static",
		})

		const friend = friends.find(
			(f) => f.id === params.friendId && f.status === "blocked",
		)
		if (!friend) {
			throw redirect({ to: "/profile/blacklist", replace: true })
		}
	},
	component: BlockedProfilePage,
})
